// extracted by mini-css-extract-plugin
export default {"academyCreateLink":"styles_academyCreateLink__B2030","academyCreateButton":"styles_academyCreateButton__Jxa7Q","fadeIn":"styles_fadeIn__hKDmk"};